import { PageHero, SplitFeature, ShippingOptions, CoverageMap, WhySection, DarkCTA } from "@/components/Sections";
import { IMAGES } from "@/data/site";

export default function Trasporti() {
  return (
    <>
      <PageHero overline="Trasporti nazionali" title="Trasporti e groupage in tutta Italia." img={IMAGES.trasporti}
        subtitle="Trasporti professionali per merci, mobilio e spedizioni dedicate, con programmazione e coordinamento di ogni servizio." />
      <SplitFeature id="trasporti-detail" overline="Su misura" reverse
        title="Dal singolo collo al carico completo."
        text="Organizziamo trasporti dedicati e groupage sulle principali tratte nazionali, con assistenza prima, durante e dopo il servizio."
        items={["Merci e pallet", "Mobilio", "Groupage", "Trasporti dedicati", "Deposito", "Assicurazione"]}
        img={IMAGES.spedizioni} cta="Richiedi preventivo" ctaPreset={{ servizio: "trasporto" }} />
      <ShippingOptions />
      <CoverageMap />
      <WhySection />
      <DarkCTA />
    </>
  );
}
